export const read_as_data_url = (file: File): Promise<string | Error> => new Promise(next => {
    const reader = new FileReader();
    reader.onload = () => next(reader.result as string);
    reader.onerror = (cause) => next(new Error('error while loading file', { cause }));
    reader.readAsDataURL(file);
});
